export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11360.97d9653f.jpg";